'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:closeAll');
}

var _invoke = require('../invoke');
var env = require('../invoke/env');
var versionCompare = require('../invoke/version-compare');

/**
 * 适用的场景是抢票任务编辑，从任务列表不想回表单.
 * ABCBC，在C页面closeAll([B, C])就退到页面A
 *
 * 与 `hbnb.webview.open` 配合使用
 *
 * 支持版本
 * + Android
 * + iHotel/6.5+
 *
 * @memberof webview
 * @static
 * @name closeAll
 * @param {Array} urls 连续关闭的URL
 * @return {Undefined}
 * @example
 *  hbnb.webview.closeAll([
 *      '/qiangpiao/add/',
 *      '/qiangpiao/list/'
 *  ]);
 */
module.exports = function(urls) {
    if (process.env.NODE_ENV !== 'production') {
        debug('url list %s', urls);
    }

    if (env.platform === 'android' && versionCompare(env.appVersion, '6.5') >= 0) {
        _invoke('webview', 'close_all', {
            urls: urls
        });
    } else {
        _invoke('webview', 'close');
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/webview/close-all.js
// module id = 658
// module chunks = 0